<template>
    <v-card class="ma-4">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :exportFileName="title"
          :allowGrouping="false"
          :allowFilterPanel="false"
          :title="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  color="blue"
                  :link="true"
                  target="_blank"
                  :to="getRoute(row.data.item)"
                >
                  <v-icon color="blue">mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("View") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="unlock(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="success">mdi-lock-open</v-icon>
                </a>
              </template>
              <span>{{ $t("Unblock") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
</template>

<script>
import SearchType from '@/ecm/variables/SearchType';
import LockedDocumentService from '@/services/LockedDocumentService';

export default {
    data() {
        return {
            title: this.$t('LockedDocuments'),
            grid: {
                key: 'lockedDocumentsGrid',
                dataSource: LockedDocumentService.getGrid(),
                columns: [
                    {
                        field: 'ContentType',
                        caption: this.$t('ContentType'),
                        type: 'string',
                    },
                    {
                        field: 'UserName',
                        caption: this.$t('User'),
                        type: 'string',
                    },
                    {
                        field: 'LockDate',
                        caption: this.$t('Date'),
                        type: 'datetime',
                        format: this.$store.getters['account/user'].MetricDateFormat + ' HH:mm:ss',
                    },
                ],
            },
        };
    },
    computed: {
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        unlock(dto) {
            LockedDocumentService.unlock([dto.Id]).then(() => {
                this.gridInstance.refresh();
            });
        },
        getRoute(dto) {
            var pattern = {
                searchPattern: dto.Id,
                searchAllVersions: true,
            };
            var route = `/search/${SearchType.DocumentIDs}/${encodeURIComponent(
                JSON.stringify(pattern)
            )}`;
            return route;
        },
    },
};
</script>
